<template>
  <div class="v-app" :class="{ RIP }">
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      RIP: Date.now() <= Date.parse("2023/11/02 23:59:59"),
    };
  },
};
</script>

<style lang="less">
.v-app {
  display: flex;
  min-height: 100%;
  flex-direction: column;

  &.RIP {
    filter: grayscale(1);
  }
}
</style>
